import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from './hoc/asyncComponent';
import Layout from './hoc/Layout';

const asyncHome = asyncComponent(() => { return import('./containers/Home'); });
const asyncAbout = asyncComponent(() => { return import('./containers/About'); });
const asyncOmBox = asyncComponent(() => { return import('./containers/OmBox'); });
const asyncContact = asyncComponent(() => { return import('./containers/Contact'); });
class App extends Component {
  render() {
    let routes = <Switch>
      <Route path="/home" component={asyncHome} />
      <Route path="/about" component={asyncAbout} />
      <Route path="/ombox" component={asyncOmBox} />
      <Route path="/contact" component={asyncContact} />

      <Route path="/" exact component={asyncHome} />

      <Redirect to="/" />
    </Switch>

    return <Layout>
      {routes}
    </Layout>
  }
}

export default App;